import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, RefreshCw, Activity, DollarSign, BarChart3 } from 'lucide-react';
import { Card } from './ui/Card';
const features = [{
  icon: CheckCircle,
  title: 'Instant Verification',
  description: 'Real-time eligibility checks against program databases ensure only active members receive benefits.'
}, {
  icon: RefreshCw,
  title: 'Automated Member Sync',
  description: 'Seamlessly sync member data between fitness centers and program providers without manual uploads.'
}, {
  icon: Activity,
  title: 'Real-Time Tracking',
  description: 'Live check-in data flows directly into your dashboard for immediate program utilization insights.'
}, {
  icon: DollarSign,
  title: 'Smart Reconciliation',
  description: 'Automated payment calculation and distribution based on verified visits and program rules.'
}, {
  icon: BarChart3,
  title: 'Advanced Analytics',
  description: 'Deep dive into program performance, member engagement trends, and ROI metrics.'
}];
export function Features() {
  return <section className="py-24 bg-white" data-id="element-189">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-191">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-192">
            Everything you need to run <br data-id="element-193" />
            <span className="text-[#0A7E8C]" data-id="element-194">successful wellness programs</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-195">
            Replace manual spreadsheets and legacy systems with a modern
            platform built for scale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-196">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-197">
              <Card className="h-full hover:shadow-md transition-shadow duration-300 border-slate-100" data-id="element-198">
                <div className="h-12 w-12 rounded-lg bg-orange-50 flex items-center justify-center mb-6" data-id="element-199">
                  <feature.icon className="h-6 w-6 text-[#FF6B35]" data-id="element-200" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-201">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-202">
                  {feature.description}
                </p>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}